export const isSameArray = (selectedOptions: string[], checkedFilters: string[]) => {
  if (selectedOptions.sort().join(',') === checkedFilters.sort().join(',')) return true;
  return false;
};

export const getUpdatedFilters = (
  checkedFilters: string[],
  isMultiSelect: boolean,
  selectedItem: string
) => {
  if (checkedFilters.includes(selectedItem))
    return checkedFilters.filter((filter) => filter !== selectedItem);
  if (!isMultiSelect) return [selectedItem];
  else return [...checkedFilters, selectedItem];
};

//get bulk selected filters when user selects Shop All in category filter
export const getBulkUpdatedFilters = (
  checkedFilters: string[],
  selectedItems: string[],
  isAllSelected: boolean
) => {
  const remainingFilters = checkedFilters.filter((filterId) => !selectedItems.includes(filterId));

  if (isAllSelected) return remainingFilters;
  else return [...checkedFilters, ...selectedItems];
};
